module.exports = __webpack_public_path__ + "static/media/fatigue_tiredness.4cd699a3.svg";